export default __webpack_public_path__ + "assets/googleauthenticator-c825fe78435c98a924875117bc80ebc4.svg";